<template>
    <div>
        <table class="table-grid w-100">
            <thead>
                <tr>
                    <th>{{ $tm('duplicate.firstname') }}</th>
                    <th>{{ $tm('duplicate.surname') }}</th>
                    <th>{{ $tm('general.race') }}</th>
                    <th>{{ $tm('general.category') }}</th>
                    <th>{{ $tm('participantid.buypass') }}</th>
                    <th>{{ $tm('participantid.nif') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(item, i) in value"
                    :key="i"
                >
                    <td>{{ item.Firstname }}</td>
                    <td>{{ item.Surname }}</td>
                    <td>{{ item.RaceName }}</td>
                    <td>{{ item.CategoryName }}</td>
                    <td>{{ item.BuypassID }}</td>
                    <td>{{ item.NifID }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup lang="ts">
/**
 * Show a list with all the duplicates found in the event
 */
import type { ImportDuplicateContestant } from '@/objects/generated';

const props = defineProps<{
    value: ImportDuplicateContestant[];
}>();
</script>
p
